module.exports = __webpack_public_path__ + "img/icon-building.e6b810c0.svg";